import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Breadcumb from './Breadcumb';
import CallToaction from './CallToaction';
import Domestic from './Domestic';
import International from './International';
import { fetchMetadata } from '../../utils/api';

function Main() {
  const [seoData, setSeoData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadMetadata = async () => {
      try {
        const data = await fetchMetadata();
        const servicesMetadata = data.find((item) => item.pageName === 'services');
        if (!servicesMetadata) {
          setError('Services page metadata not found');
          setLoading(false);
          return;
        }
        setSeoData(servicesMetadata);
        setLoading(false);
      } catch (err) {
        setError('Failed to load SEO metadata');
        setLoading(false);
      }
    };
    loadMetadata();
  }, []);

  return (
    <>
      <Helmet>
        <title>{seoData?.title || 'Services | Bluelagoon Travels'}</title>
        <meta
          name='description'
          content={seoData?.description || 'Explore travel services with Bluelagoon Travels.'}
        />
        <meta
          name='keywords'
          content={seoData?.keywords || 'travel services, booking'}
        />
        <meta
          name='pageName'
          content={seoData?.pageName || 'services'}
        />
      </Helmet>
      <Breadcumb />
      <Domestic />
      <International />
      <CallToaction />
    </>
  );
}

export default Main;
